import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Breadcrumb, Table, CardHeader, Form, FormGroup, InputGroup, FormLabel } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { Link, useNavigate, useParams } from 'react-router-dom'; // Assuming React Router is used
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import '../../assets/css/invoice.css'
import GifLoder from '../../components/GifLoder';
// import { toWords } from "number-to-words";
import { Dialog } from "primereact/dialog";
import successVideo from '../../assets/video/paperplane.mp4';
import crossVideo from '../../assets/video/cross.mp4';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ToWords } from 'to-words';


const CreateTaxInvoice = () => {
    const navigate = useNavigate();
    const { accessToken } = useAuth();
    const { templateId } = useParams(); // Get template_id from URL params
    const [template, setTemplate] = useState(null);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const dueDate = new Date();
    dueDate.setDate(dueDate.getDate());
    dueDate.setHours(0, 0, 0, 0);
    const [loading, setLoading] = useState(true);
    const [invoice_type, setInvoiceType] = useState("New");
    const [date, setDate] = useState(currentDate);
    const [duedate, setDuedate] = useState(dueDate);
    const [recurring_date, setRecurringDate] = useState(null);
    const [amountInWords, setAmountInWords] = useState("");
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    //*--------------------------------Manual client variables ----------------------------------*//
    const initialClientDetails = {
        Billing_name: "",
        comp_name: "",
        bill_name: "",
        email: "",
        phone: "",
        bill_address: "",
        poc: "",
        gstin: "",
        pan: "",
        cc_emails: "",
        bcc_emails: ""
    };

    const [clientDetails, setClientDetails] = useState(initialClientDetails);
    const [sameAsBilling, setSameAsBilling] = useState(false);
    const [shippingName, setShippingName] = useState("");
    const [shippingAddress, setShippingAddress] = useState("");
    const [shippingPhone, setShippingPhone] = useState("");

    const handleClientDetailsChange = (field, value) => {
        setClientDetails((previous) => ({ ...previous, [field]: value }));

        if (sameAsBilling) {
            if (field === "bill_name" || field === "Billing_name") {
                setShippingName(field === "bill_name" ? value : clientDetails.bill_name || value);
            }
            if (field === "bill_address") setShippingAddress(value);
            if (field === "phone") setShippingPhone(value);
        }
    };

    //*-----------------------------------Data variables ----------------------------------*//
    const [supplyAttractReverses, setSupplyAttractReverses] = useState("No");
    const [lutArn, setLutArn] = useState("");
    const [MSME_type, setMSME_type] = useState("");
    const [MSME_Number, setMSME_Number] = useState("");
    const [currency, setCurrency] = useState("INR");
    const [tax, setTax] = useState("Cgst+Sgst");
    const [showLut, setShowLut] = useState("Default select");
    const [remarks, setRemarks] = useState("");
    const [cgst, setCgst] = useState(0);
    const [sgst, setSgst] = useState(0);
    const [igst, setIgst] = useState(0);
    const [gst, setGst] = useState(0);


    const currencySymbols = {
        INR: "₹ ",
        USD: "$ ",
        GBP: "£ ",
        EUR: "€ ",
        AED: "د.إ ",
        AUD: "A$ ",
        CAD: "C$ "
    };

    const getCurrencySymbol = (currencyCode) => {
        return currencySymbols[currencyCode] || currencyCode; // Default to currency code if not found
    };


    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setSameAsBilling(isChecked);

        if (isChecked) {
            setShippingName(clientDetails.bill_name || clientDetails.Billing_name || "");
            setShippingAddress(clientDetails.bill_address || "");
            setShippingPhone(clientDetails.phone || "");
        } else {
            setShippingName("");
            setShippingAddress("");
            setShippingPhone("");
        }
    };

    const resetSearch = () => {
        setClientDetails(initialClientDetails);
        setSameAsBilling(false);
        setShippingName("");
        setShippingAddress("");
        setShippingPhone("");
    };

    const handleCurrencyChange = (e) => {
        const selectedCurrency = e.target.value;
        setCurrency(selectedCurrency);
        if (selectedCurrency !== "INR") {
            setTax("Disabled");
            setShowLut("Yes");
            setCgst(0);
            setSgst(0);
            setIgst(0);
            setGst(0);
        } else {
            setTax("Cgst+Sgst");
            setShowLut("No");
        }
    };

    const handleTaxChange = (e) => {
        const selectedTax = e.target.value;
        setTax(selectedTax);
        setCgst(0); // Set to number instead of string
        setSgst(0);
        setIgst(0);
        setGst(0);
    };



    const [rows, setRows] = useState([
        { description: "", sac_code: "", hsn: "", quantity: "1", price: "", remarks: "", subtotal_price: "" }
    ]);

    const handleAddRow = () => {
        setRows([...rows, { description: "", sac_code: "", hsn: "", quantity: "1", price: "", remarks: "", subtotal_price: "" }]);
    };

    const handleRemoveRow = (indexToRemove) => {
        setRows(rows.filter((_, index) => index !== indexToRemove));
    };

    // Function to update a specific row's value
    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;

        // Recalculate subtotal_price when price or quantity changes
        if (field === "price" || field === "quantity") {
            const price = parseFloat(updatedRows[index].price) || 0;
            const quantity = parseInt(updatedRows[index].quantity, 10) || 0;
            updatedRows[index].subtotal_price = price * quantity;
        }

        setRows(updatedRows);
    };


    // Reorder function
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragEnd = (result) => {
        if (!result.destination) return; // dropped outside the list
        const updatedRows = reorder(rows, result.source.index, result.destination.index);
        setRows(updatedRows);
    };

    const calculateTotalAmount = () => {
        let totalAmount = 0;
        let igstAmount = 0;
        let cgstAmount = 0;
        let sgstAmount = 0;
        let gstAmount = 0;

        rows.forEach((row) => {
            const price = parseFloat(row.price) || 0;  // Default to 0 if NaN
            const quantity = parseInt(row.quantity, 10) || 0; // Default to 0 if NaN

            if (!isNaN(price) && !isNaN(quantity)) {
                const rowTotal = price * quantity; // Multiply price with quantity
                totalAmount += rowTotal;
            }
        });

        // Ensure parsed values default to 0 if empty or NaN
        const parsedCgst = parseFloat(cgst) || 0;
        const parsedSgst = parseFloat(sgst) || 0;
        const parsedIgst = parseFloat(igst) || 0;
        const parsedGst = parseFloat(gst) || 0;

        // Calculate tax based on selection
        if (tax === "Cgst+Sgst") {
            cgstAmount = (totalAmount * parsedCgst) / 100;
            sgstAmount = (totalAmount * parsedSgst) / 100;
        } else if (tax === "Igst") {
            igstAmount = (totalAmount * parsedIgst) / 100;
        } else if (tax === "GST") {
            gstAmount = (totalAmount * parsedGst) / 100;
        }

        return { totalAmount, cgstAmount, sgstAmount, igstAmount, gstAmount };
    };

    const { totalAmount, cgstAmount, sgstAmount, igstAmount, gstAmount } = calculateTotalAmount();
    const total_tax = cgstAmount + sgstAmount + igstAmount + gstAmount;

    const fetchTemplate = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/fetch-specific-template/${templateId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 204) {
                setTemplate(null); // No Content
            } else {
                setTemplate(response.data.data);
                setMSME_Number(response.data.data.MSME_Number);
                setLutArn(response.data.data.Lut_Arn_No);
                setMSME_type(response.data.data.MSME_Type);
            }
        } catch (err) {
            console.error('Error fetching templates:', err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (templateId) {
            fetchTemplate();
        }
    }, [templateId, accessToken]);







    const resetPage = () => {
        // Reset all state variables
        setTemplate(null);
        setLoading(true);
        setAmountInWords("");

        // Reset manual client details
        setClientDetails(initialClientDetails);
        setSameAsBilling(false);
        setShippingName("");
        setShippingAddress("");
        setShippingPhone("");

        // Reset data variables
        setSupplyAttractReverses("No");
        setCurrency("Default select");
        setTax("Default select");
        setShowLut("Default select");
        setRemarks("");
        setCgst(0);
        setSgst(0);
        setIgst(0);
        setGst(0);
        // Reset dynamic rows
        setRows([{ description: '', sac_code: '', hsn: '', quantity: '1', price: '', subtotal_price: "", remarks: "" }]);

        // Re-fetch initial data
        if (templateId) {
            fetchTemplate();
        }
    };



    const validateTaxInvoice = () => {
        if (!clientDetails.Billing_name.trim()) throw new Error("Billing name is required.");
        if (!clientDetails.bill_name.trim()) throw new Error("Name on invoice is required.");
        if (!clientDetails.email.trim()) throw new Error("Email is required.");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clientDetails.email.trim())) {
            throw new Error("Enter a valid email address.");
        }
        if (!clientDetails.bill_address.trim()) throw new Error("Billing address is required.");
        if (!rows.length) throw new Error("Add at least one product.");

        rows.forEach((row, index) => {
            if (!String(row.description || "").trim()) {
                throw new Error(`Product description is required in row ${index + 1}.`);
            }
            if (Number(row.quantity) <= 0) {
                throw new Error(`Quantity must be greater than zero in row ${index + 1}.`);
            }
            if (row.price === "" || !Number.isFinite(Number(row.price)) || Number(row.price) < 0) {
                throw new Error(`Enter a valid price in row ${index + 1}.`);
            }
        });
    };

    const addInvoice = async () => {
        setLoading(true);
        try {
            validateTaxInvoice();

            const resolvedShippingName = sameAsBilling
                ? clientDetails.bill_name || clientDetails.Billing_name
                : shippingName;
            const resolvedShippingAddress = sameAsBilling
                ? clientDetails.bill_address
                : shippingAddress;
            const resolvedShippingPhone = sameAsBilling
                ? clientDetails.phone
                : shippingPhone;

            const invoiceData = {
                template_id: Number(templateId),

                Billing_name: clientDetails.Billing_name.trim(),
                comp_name: clientDetails.comp_name.trim() || clientDetails.Billing_name.trim(),
                bill_name: clientDetails.bill_name.trim() || clientDetails.Billing_name.trim(),
                bill_address: clientDetails.bill_address.trim(),
                email: clientDetails.email.trim().toLowerCase(),
                phone: clientDetails.phone.trim() || null,
                poc: clientDetails.poc.trim() || clientDetails.Billing_name.trim(),
                gstin: clientDetails.gstin.trim() || null,
                pan: clientDetails.pan.trim() || null,
                cc_emails: clientDetails.cc_emails.trim() || null,
                bcc_emails: clientDetails.bcc_emails.trim() || null,

                template_name: template?.header_text || "",
                signature_url: template?.signatures?.[0]?.signature_url || "",
                logo_url: template?.headerLogos?.[0]?.header_logo_url || "",
                currency,
                sub_total: Number(totalAmount.toFixed(2)),
                tax_type: tax,
                tax: Number(total_tax.toFixed(2)),
                lut: showLut === "Yes",
                total: Number((totalAmount + total_tax).toFixed(2)),
                issue_date: date.toLocaleDateString("en-CA"),
                due_date: duedate.toLocaleDateString("en-CA"),
                cgst: Number(cgst || 0),
                sgst: Number(sgst || 0),
                igst: Number(igst || 0),
                gst: Number(gst || 0),
                cgst_value: Number(cgstAmount.toFixed(2)),
                sgst_value: Number(sgstAmount.toFixed(2)),
                igst_value: Number(igstAmount.toFixed(2)),
                gst_value: Number(gstAmount.toFixed(2)),
                shipping_address: resolvedShippingAddress,
                shipping_name: resolvedShippingName,
                shipping_phone: resolvedShippingPhone || null,
                remarks: remarks.trim() || null,
                Lut_Arn_No: lutArn || null,
                MSME_Type: MSME_type || null,
                MSME_Number: MSME_Number || null,
                supplyAttractReverses,
                sameAsBilling,
                invoice_products: rows.map((row) => ({
                    description: String(row.description || "").trim(),
                    sac_code: String(row.sac_code || "").trim() || null,
                    hsn: String(row.hsn || "").trim() || null,
                    quantity: Number(row.quantity || 0),
                    price: Number(Number(row.price || 0).toFixed(2)),
                    remarks: String(row.remarks || "").trim() || null,
                    subtotal_price: Number((Number(row.price || 0) * Number(row.quantity || 0)).toFixed(2)),
                })),
            };

            const response = await axios.post(
                `${config.apiBASEURL}/InvoiceRoutes/create-tax-invoice`,
                invoiceData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    navigate('/Graphe/dashboard/invoice_list');
                }, 2000);
            }
        } catch (error) {
            console.error("Error creating tax invoice:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => setVideocrossDialogVisible(false), 2000);
        } finally {
            setLoading(false);
        }
    };

    /*------------to-words function --------------*/
    const currencyWordConfig = {
        INR: { name: "Rupee", plural: "Rupees", fraction: "Paisa", fractionPlural: "Paise" },
        USD: { name: "Dollar", plural: "Dollars", fraction: "Cent", fractionPlural: "Cents" },
        EUR: { name: "Euro", plural: "Euros", fraction: "Cent", fractionPlural: "Cents" },
        GBP: { name: "Pound", plural: "Pounds", fraction: "Pence", fractionPlural: "Pence" },
        AED: { name: "Dirham", plural: "Dirhams", fraction: "Fils", fractionPlural: "Fils" },
        AUD: { name: "Australian Dollar", plural: "Australian Dollars", fraction: "Cent", fractionPlural: "Cents" },
        CAD: { name: "Canadian Dollar", plural: "Canadian Dollars", fraction: "Cent", fractionPlural: "Cents" }
    };

    // ⭐ FINAL FUNCTION (INR → en-IN | Others → en-US)
    const convertAmountToWords = (amount, currencyCode) => {
        const c = currencyWordConfig[currencyCode] ?? currencyWordConfig["INR"];

        // Use Indian Numbering System only for INR
        const locale = currencyCode === "INR" ? "en-IN" : "en-US";

        const toWords = new ToWords({
            localeCode: locale,
            converterOptions: {
                currency: true,
                ignoreDecimal: false,
                currencyOptions: {
                    name: c.name,
                    plural: c.plural,
                    symbol: currencySymbols[currencyCode],
                    fractionalUnit: {
                        name: c.fraction,
                        plural: c.fractionPlural,
                        symbol: ""
                    }
                }
            }
        });

        return toWords.convert(amount);
    };

    // ⭐ USE EFFECT (NO CHANGE)
    useEffect(() => {
        const total = totalAmount + cgstAmount + sgstAmount + igstAmount + gstAmount;

        const words = convertAmountToWords(total, currency);

        setAmountInWords(words);
    }, [totalAmount, cgstAmount, sgstAmount, igstAmount, gstAmount, currency]);



    return (
        <>
            {loading ? (
                <div className="loderDiv">
                    <GifLoder />
                </div>
            ) : (
                <Row className="body_content">
                    <Row className="mx-0">
                        <Col sm={6} className="mb-4 d-flex justify-content-between align-items-center">
                            <Breadcrumb>
                                <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                                    <i className="pi pi-angle-left"></i> Back
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>Create Tax Invoice</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                        <Col md={6} lg={6} className='mb-4 d-flex justify-content-end'>
                            <Button label="Reset" className="btn btn-secondary me-2" onClick={resetPage} />
                            <Button label="Save Invoice" className="btn btn-success" onClick={addInvoice} />
                        </Col>
                        <Row className='mx-0 adInv'>
                            <Col md={12} lg={7} className="p-0">
                                <Card className='h-auto p-4 sticky-top'>
                                    <Row className='justify-content-start mb-4'>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label htmlFor="issueDate">Issue Date
                                                    <i
                                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                        data-pr-tooltip="Note: This date will change when invoice is sent."
                                                        data-pr-position="right"
                                                        data-pr-at="right+5 top"
                                                        data-pr-my="left center-2"
                                                    >
                                                    </i>
                                                    <Tooltip target=".custom-target-icon" />
                                                </Form.Label>
                                                <Calendar
                                                    id="issueDate"
                                                    value={date}
                                                    onChange={(e) => setDate(e.value)}
                                                    dateFormat="dd/mm/yy"
                                                    placeholder="DD/MM/YYYY"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>MSME_Type <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control
                                                    value={MSME_type}
                                                    readOnly
                                                    text
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>MSME_Number <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control
                                                    value={MSME_Number}
                                                    readOnly
                                                    text
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Supply Attract Reveres</Form.Label>
                                                <Form.Select value={supplyAttractReverses} onChange={(e) => setSupplyAttractReverses(e.target.value)}>
                                                    <option>Yes</option>
                                                    <option>No</option>
                                                </Form.Select>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label htmlFor="dueDate">Payment Due Date
                                                    <i
                                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                        data-pr-tooltip="Note: Date the payment of this invoice is due."
                                                        data-pr-position="right"
                                                        data-pr-at="right+5 top"
                                                        data-pr-my="left center-2"
                                                    >
                                                    </i>
                                                    <Tooltip target=".custom-target-icon" />
                                                </Form.Label>
                                                <Calendar
                                                    id="dueDate"
                                                    value={duedate}
                                                    onChange={(e) => setDuedate(e.value)}
                                                    dateFormat="dd/mm/yy"
                                                    placeholder="DD/MM/YYYY"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Invoice Type</Form.Label>
                                                <Form.Select value={invoice_type} onChange={(e) => setInvoiceType(e.target.value)}>
                                                    <option>New</option>
                                                </Form.Select>
                                            </FormGroup>
                                        </Col>
                                        {invoice_type === "Recurring" && (
                                            <Col md={6} lg={4}>
                                                <FormGroup>
                                                    <Form.Label htmlFor="dueDate">Recurring Date
                                                        <i
                                                            className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                            data-pr-tooltip="Note: Date the Invoice will be automatically generated every month on that date and sent to Draft."
                                                            data-pr-position="right"
                                                            data-pr-at="right+5 top"
                                                            data-pr-my="left center-2"
                                                        >
                                                        </i>
                                                        <Tooltip target=".custom-target-icon" />
                                                    </Form.Label>
                                                    <Calendar
                                                        id="recurring_date"
                                                        value={recurring_date}
                                                        onChange={(e) => setRecurringDate(e.value)}
                                                        dateFormat="dd/mm/yy"
                                                        placeholder="DD/MM/YYYY"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        )}
                                        {showLut === "Yes" && (
                                            <Col md={6} lg={4}>
                                                <FormGroup>
                                                    <Form.Label>LUT ARN</Form.Label>
                                                    <Form.Control value={lutArn} readOnly />
                                                </FormGroup>
                                            </Col>
                                        )}


                                    </Row>

                                    <Row className="mb-4 p-3 bg-light position-relative">
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Billing Name <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type="text" value={clientDetails.Billing_name} onChange={(e) => handleClientDetailsChange("Billing_name", e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Company Name</Form.Label>
                                                <Form.Control type="text" value={clientDetails.comp_name} onChange={(e) => handleClientDetailsChange("comp_name", e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Name on Invoice <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type="text" value={clientDetails.bill_name} onChange={(e) => handleClientDetailsChange("bill_name", e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Email <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type="email" value={clientDetails.email} onChange={(e) => handleClientDetailsChange("email", e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Phone</Form.Label>
                                                <Form.Control type="text" value={clientDetails.phone} onChange={(e) => handleClientDetailsChange("phone", e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Point of Contact</Form.Label>
                                                <Form.Control type="text" value={clientDetails.poc} onChange={(e) => handleClientDetailsChange("poc", e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>GSTIN</Form.Label>
                                                <Form.Control type="text" value={clientDetails.gstin} onChange={(e) => handleClientDetailsChange("gstin", e.target.value.toUpperCase())} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>PAN</Form.Label>
                                                <Form.Control type="text" value={clientDetails.pan} onChange={(e) => handleClientDetailsChange("pan", e.target.value.toUpperCase())} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>CC Emails</Form.Label>
                                                <Form.Control type="text" value={clientDetails.cc_emails} onChange={(e) => handleClientDetailsChange("cc_emails", e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>BCC Emails</Form.Label>
                                                <Form.Control type="text" value={clientDetails.bcc_emails} onChange={(e) => handleClientDetailsChange("bcc_emails", e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Form.Label>Billing Address <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control as="textarea" rows={4} value={clientDetails.bill_address} onChange={(e) => handleClientDetailsChange("bill_address", e.target.value)} />
                                            </FormGroup>
                                        </Col>

                                        <Col md={12} className="mt-3">
                                            <Form.Check type="checkbox" label="Same as Billing Address" checked={sameAsBilling} onChange={handleCheckboxChange} />
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Shipping Name</Form.Label>
                                                <Form.Control type="text" value={shippingName} onChange={(e) => setShippingName(e.target.value)} disabled={sameAsBilling} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Shipping Address</Form.Label>
                                                <Form.Control as="textarea" rows={2} value={shippingAddress} onChange={(e) => setShippingAddress(e.target.value)} disabled={sameAsBilling} />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Shipping Phone</Form.Label>
                                                <Form.Control type="text" value={shippingPhone} onChange={(e) => setShippingPhone(e.target.value)} disabled={sameAsBilling} />
                                            </FormGroup>
                                        </Col>
                                        <div style={{ position: 'absolute', top: '-13px', right: '-18px', width: 'auto' }}>
                                            <Button title='Reset' onClick={resetSearch} icon="pi pi-refresh" rounded text severity="danger" aria-label="Reset client details" />
                                        </div>
                                    </Row>
                                    <Row className="mb-4 pb-4 border-bottom">
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Currency</Form.Label>
                                                <Form.Select value={currency} onChange={handleCurrencyChange}>
                                                    <option value="INR">Rupee (INR)</option>
                                                    <option value="USD">US Dollar (USD)</option>
                                                    <option value="GBP">British Pound (GBP)</option>
                                                    <option value="EUR">Euro (EUR)</option>
                                                    <option value="AED">UAE Dirham (AED)</option>
                                                    <option value="AUD">Australian Dollar (AUD)</option>
                                                    <option value="CAD">Canadian Dollar (CAD)</option>
                                                </Form.Select>
                                            </FormGroup>
                                        </Col>

                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Show LUT</Form.Label>
                                                <Form.Select value={showLut} onChange={(e) => setShowLut(e.target.value)} disabled>
                                                    <option>Default select</option>
                                                    <option>Yes</option>
                                                    <option>No</option>
                                                </Form.Select>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6} lg={4}>
                                            <FormGroup>
                                                <Form.Label>Tax</Form.Label>
                                                <Form.Select value={tax} onChange={handleTaxChange} disabled={currency !== "INR"}>
                                                    <option>Default select</option>
                                                    <option value="Cgst+Sgst">CGST + SGST</option>
                                                    <option value="Igst">IGST</option>
                                                    <option value="GST">GST</option>
                                                </Form.Select>
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    {/* <Row className="mb-4 pb-4 border-bottom">
                                        {tax === "Cgst+Sgst" && (
                                            <>
                                                <Col md={6} lg={4}>
                                                    <FormGroup>
                                                        <Form.Label>CGST (%) <span className='text-danger'>*</span></Form.Label>
                                                        <Form.Control
                                                            value={cgst}
                                                            onChange={(e) => setCgst(e.target.value === "" ? "" : Number(e.target.value))}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6} lg={4}>
                                                    <FormGroup>
                                                        <Form.Label>SGST (%) <span className='text-danger'>*</span></Form.Label>
                                                        <Form.Control
                                                            value={sgst}
                                                            onChange={(e) => setSgst(e.target.value === "" ? "" : Number(e.target.value))}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </>
                                        )}
                                        {tax === "Igst" && (
                                            <Col md={6} lg={4}>
                                                <FormGroup>
                                                    <Form.Label>IGST (%) <span className='text-danger'>*</span></Form.Label>
                                                    <Form.Control
                                                        value={igst}
                                                        onChange={(e) => setIgst(e.target.value === "" ? "" : Number(e.target.value))}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        )}
                                        {tax === "GST" && (
                                            <Col md={6} lg={4}>
                                                <FormGroup>
                                                    <Form.Label>GST (%) <span className='text-danger'>*</span></Form.Label>
                                                    <Form.Control value={gst} disabled />
                                                </FormGroup>
                                            </Col>
                                        )}
                                        {showLut === "Yes" && (
                                            <Col md={6} lg={4}>
                                                <FormGroup>
                                                    <Form.Label>Without Payment of Tax under LUT No.</Form.Label>
                                                    <Form.Control value={lutArn} disabled />
                                                </FormGroup>
                                            </Col>
                                        )}


                                    </Row> */}

                                    <Row className="mb-4 pb-4 border-bottom">
                                        {tax === "Cgst+Sgst" && (
                                            <>
                                                <Col md={6} lg={4}>
                                                    <FormGroup>
                                                        <Form.Label>
                                                            CGST (%) <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={cgst}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Allow only numbers with up to 3 decimals
                                                                if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                                                                    setCgst(value);
                                                                }
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>

                                                <Col md={6} lg={4}>
                                                    <FormGroup>
                                                        <Form.Label>
                                                            SGST (%) <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={sgst}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                                                                    setSgst(value);
                                                                }
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </>
                                        )}

                                        {tax === "Igst" && (
                                            <Col md={6} lg={4}>
                                                <FormGroup>
                                                    <Form.Label>
                                                        IGST (%) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={igst}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                                                                setIgst(value);
                                                            }
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        )}

                                        {tax === "GST" && (
                                            <Col md={6} lg={4}>
                                                <FormGroup>
                                                    <Form.Label>
                                                        GST (%) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control value={gst} disabled />
                                                </FormGroup>
                                            </Col>
                                        )}

                                        {showLut === "Yes" && (
                                            <Col md={6} lg={4}>
                                                <FormGroup>
                                                    <Form.Label>Without Payment of Tax under LUT No.</Form.Label>
                                                    <Form.Control value={lutArn} disabled />
                                                </FormGroup>
                                            </Col>
                                        )}
                                    </Row>




                                    <Card.Title className='mb-5 d-flex justify-content-between align-items-center sticky-top bg-white' style={{ zIndex: '99 !important', padding: '10px', top: '-35px' }}>
                                        Products
                                        <Button onClick={handleAddRow} className="btn btn-info">Add +</Button>
                                    </Card.Title>
                                    <div className="service_form">
                                        <DragDropContext onDragEnd={onDragEnd}>
                                            <Droppable droppableId="serviceList">
                                                {(provided) => (
                                                    <div
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                        className="service_form"
                                                    >
                                                        {rows.map((row, index) => (
                                                            <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                                                {(provided) => (
                                                                    <Row
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        key={index}
                                                                        className="mb-4 pb-4 border-bottom bg-light rounded"
                                                                        style={{
                                                                            ...provided.draggableProps.style,
                                                                            padding: '10px',
                                                                            userSelect: 'none',
                                                                        }}
                                                                    >
                                                                        <Col md={12} lg={12} className='px-0'>
                                                                            <InputGroup className="mb-3 addSER position-relative">
                                                                                <div style={{ width: '180px' }} className='px-1'>
                                                                                    <FormLabel>Description</FormLabel>
                                                                                    <Form.Control
                                                                                        placeholder="Description"
                                                                                        value={row.description}
                                                                                        onChange={(e) => handleInputChange(index, "description", e.target.value)}
                                                                                        className='w-100 me-1'
                                                                                    />
                                                                                </div>
                                                                                <div className='px-1'>
                                                                                    <FormLabel>SAC Code</FormLabel>
                                                                                    <Form.Control
                                                                                        placeholder="SAC Code"
                                                                                        value={row.sac_code}
                                                                                        type="text"
                                                                                        onChange={(e) => handleInputChange(index, "sac_code", e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                <div className='px-1'>
                                                                                    <FormLabel>HSN Code</FormLabel>
                                                                                    <Form.Control
                                                                                        placeholder="HSN"
                                                                                        value={row.hsn}
                                                                                        type="text"
                                                                                        onChange={(e) => handleInputChange(index, "hsn", e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                <div className='px-1'>
                                                                                    <FormLabel>QTY</FormLabel>
                                                                                    <Form.Control
                                                                                        placeholder="QTY"
                                                                                        value={row.quantity}
                                                                                        onChange={(e) => handleInputChange(index, 'quantity', e.target.value)}
                                                                                        type="number"
                                                                                    />
                                                                                </div>

                                                                                <div className='px-1'>
                                                                                    <FormLabel>Price
                                                                                        <i
                                                                                            className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                                                            data-pr-tooltip="Note: Per unit price of the service"
                                                                                            data-pr-position="right"
                                                                                            data-pr-at="right+5 top"
                                                                                            data-pr-my="left center-2"
                                                                                        >
                                                                                        </i>
                                                                                        <Tooltip target=".custom-target-icon" />
                                                                                    </FormLabel>
                                                                                    <Form.Control
                                                                                        placeholder="Price"
                                                                                        value={row.price}
                                                                                        onChange={(e) => handleInputChange(index, 'price', e.target.value)}
                                                                                        type="number"
                                                                                    />
                                                                                </div>
                                                                                <div className='px-1'>
                                                                                    <FormLabel>Sub Total Price
                                                                                        <i
                                                                                            className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                                                            data-pr-tooltip="Note: Total Price of the service without Taxes"
                                                                                            data-pr-position="right"
                                                                                            data-pr-at="right+5 top"
                                                                                            data-pr-my="left center-2"
                                                                                        >
                                                                                        </i>
                                                                                        <Tooltip target=".custom-target-icon" />
                                                                                    </FormLabel>
                                                                                    <Form.Control
                                                                                        placeholder="Sub Total Price"
                                                                                        value={row.subtotal_price}
                                                                                        onChange={(e) => handleInputChange(index, 'subtotal_price', e.target.value)}
                                                                                        type="number"
                                                                                    />
                                                                                </div>

                                                                                <div className='px-1 w-100'>
                                                                                    <FormLabel>Remarks
                                                                                        <i
                                                                                            className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                                                            data-pr-tooltip="Note: Wont be visible in the PDF invoice"
                                                                                            data-pr-position="right"
                                                                                            data-pr-at="right+5 top"
                                                                                            data-pr-my="left center-2"
                                                                                        >
                                                                                        </i>
                                                                                        <Tooltip target=".custom-target-icon" />
                                                                                    </FormLabel>
                                                                                    <Form.Control
                                                                                        placeholder="Remarks"
                                                                                        value={row.remarks}
                                                                                        onChange={(e) => handleInputChange(index, "remarks", e.target.value)}
                                                                                        type="text"
                                                                                    />
                                                                                </div>

                                                                                <InputGroup.Text className="border-0 removeBTN">
                                                                                    <Button onClick={() => handleRemoveRow(index)} icon="pi pi-times" rounded text severity="danger" aria-label="Cancel" />
                                                                                </InputGroup.Text>
                                                                            </InputGroup>

                                                                        </Col>
                                                                    </Row>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>

                                        <Row className="justify-content-between invtable">
                                            <Col md={6} lg={6} className='invRadio'>
                                                <FormGroup>
                                                    <Form.Label>Remarks: <span className="text-danger">(Optional)</span></Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        placeholder="Leave a comment here"
                                                        className="h-auto"
                                                        rows={4}
                                                        value={remarks}
                                                        onChange={(e) => setRemarks(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6} lg={5}>
                                                <Table striped size="sm">
                                                    <thead>
                                                        <tr>
                                                            <td>Amount :</td>
                                                            <th><span>{getCurrencySymbol(currency)}</span>{totalAmount.toFixed(2)}</th>
                                                        </tr>

                                                        {tax === "Cgst+Sgst" && (
                                                            <>
                                                                <tr>
                                                                    <td>CGST ({cgst}%)</td>
                                                                    <th><span>{getCurrencySymbol(currency)}</span>{cgstAmount.toFixed(2)}</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>SGST ({sgst}%)</td>
                                                                    <th><span>{getCurrencySymbol(currency)}</span>{sgstAmount.toFixed(2)}</th>
                                                                </tr>
                                                            </>
                                                        )}

                                                        {tax === "Igst" && (
                                                            <tr>
                                                                <td>IGST ({igst}%)</td>
                                                                <th><span>{getCurrencySymbol(currency)}</span>{igstAmount.toFixed(2)}</th>
                                                            </tr>
                                                        )}

                                                        {tax === "GST" && (
                                                            <tr>
                                                                <td>GST ({gst}%)</td>
                                                                <th><span>{getCurrencySymbol(currency)}</span>{gstAmount.toFixed(2)}</th>
                                                            </tr>
                                                        )}

                                                        <tr>
                                                            <td>Total Taxes</td>
                                                            <th><span>{getCurrencySymbol(currency)}</span>{total_tax.toFixed(2)}</th>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Total Amount :</b></td>
                                                            <th><span>{getCurrencySymbol(currency)}</span>{(totalAmount + cgstAmount + sgstAmount + igstAmount + gstAmount).toFixed(2)}</th>
                                                        </tr>
                                                    </thead>
                                                </Table>
                                            </Col>
                                            <Col md={12} lg={12} className="text-end mt-4">
                                                <Button label="Reset" className="btn btn-secondary me-2" onClick={resetPage} />
                                                <Button label="Save Invoice" className="btn btn-success" onClick={addInvoice} />
                                            </Col>
                                        </Row>
                                    </div>
                                </Card>
                            </Col>
                            <Col md={6} lg={5} className="ps-4 pe-0">
                                <div className="template_sec">
                                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '0', fontFamily: 'Roboto', background: '#fff' }}>
                                        <thead>
                                            <tr style={{ borderBottom: '1px solid #ddd' }}>
                                                <td colspan="3" style={{ padding: '10px', Width: '300px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={template?.headerLogos?.[0]?.header_logo_url} alt="Company Logo" style={{ height: '170px', width: '170px', objectFit: 'contain' }} />
                                                        <div style={{ width: 'calc(100% - 120px)', marginLeft: '30px' }}>
                                                            <h2 style={{ margin: '5px 0 0 0', fontSize: '20px', color: '#494949', textTransform: 'uppercase' }}>The Graphē</h2>
                                                            <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: '400', color: '#858585' }}>A Design Studio</p>
                                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', lineHeight: '20px', color: '#494949', width: '200px' }}>{template.company_address || "N/A"}</p>
                                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>GSTIN No. : <b>{template.GSTIN}</b></p>
                                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>MSME No. : <b>{MSME_Number}</b> <small style={{ color: '#858585' }}>({MSME_type})</small></p>
                                                            {showLut === "Yes" && (<p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>LUT No. : <b>{lutArn}</b></p>)}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ padding: "10px", textAlign: "right", verticalAlign: "top", width: "280px", paddingLeft: "65px" }} colspan="2" >
                                                    <h3 style={{ margin: "5px 0 10px 0", fontSize: "26px", color: "#000" }}>{template.header_text}</h3>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="5" style={{ padding: "8px 0" }}></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={{ padding: "10px 15px 10px 10px", verticalAlign: "top" }}>
                                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Bill To :</p>
                                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                                        <li style={{ display: "flex" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                                {clientDetails.bill_name || clientDetails.Billing_name || "N/A"}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>Poc : </span>
                                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                                {clientDetails.poc || "N/A"}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>Email : </span>
                                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                                {clientDetails?.email || "N/A"}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                                {clientDetails?.phone || "N/A"}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>GSTIN :</span>
                                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                                {clientDetails?.gstin || "N/A"}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)" }}>
                                                                {clientDetails?.bill_address || "N/A"}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </td>
                                                <td colSpan="2" style={{ padding: "10px", verticalAlign: "top" }}>
                                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Ship To :</p>
                                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                                        <li style={{ display: "flex" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                                {shippingName || "N/A"}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                                {shippingPhone || "N/A"}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex", lineHeight: "1.3", marginTop: "5px" }}>
                                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)", }}>
                                                                {shippingAddress || "N/A"}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </td>
                                                <td colSpan="1" style={{ padding: "10px", verticalAlign: "top", width: "200px" }}>
                                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                                            <span style={{ width: "70px", marginRight: "5px" }}>Invoice # :</span>
                                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                                {template.invoice_prefix}_/{template.financial_year}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                                            <span style={{ width: "70px", marginRight: "5px" }}>Issue Date :</span>
                                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                                {new Date(date).toLocaleDateString("en-GB")}
                                                            </span>
                                                        </li>
                                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                                            <span style={{ width: "70px", marginRight: "5px" }}>Due Date :</span>
                                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                                {new Date(duedate).toLocaleDateString("en-GB")}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="5" style={{ padding: '10px 0' }}></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ backgroundColor: '#e7e7e7', textAlign: 'left' }}>
                                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '230px' }}>Description</th>
                                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>SAC/HSN</th>
                                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Rate</th>
                                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Qty</th>
                                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '100px' }}>Sub Total</th>
                                            </tr>
                                            {rows.map((product, index) => (
                                                <tr key={index}>
                                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                                        <span style={{ display: 'block', marginBottom: '3px' }}>{index + 1}. {product.description}</span>
                                                        {product.Remarks && (
                                                            <small style={{ fontSize: '11px', lineHeight: '1.2' }} className="text-secondary d-block">
                                                                <b>Remarks :</b> {product.Remarks}
                                                            </small>
                                                        )}
                                                    </td>
                                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                                        {product.hsn ? `HSN-${product.hsn}` : product.sac_code ? `SAC-${product.sac_code}` : '-'}
                                                    </td>
                                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                                        {getCurrencySymbol(currency)} {product.price}
                                                    </td>
                                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>{product.quantity}</td>
                                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                                        {getCurrencySymbol(currency)} {product.subtotal_price}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <th colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Subtotal:</th>
                                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(currency)} {totalAmount.toFixed(2)}</th>
                                            </tr>
                                            {tax === "Cgst+Sgst" && (
                                                <>
                                                    <tr>
                                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>CGST ({cgst}%):</td>
                                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(currency)} {cgstAmount.toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>SGST ({sgst}%):</td>
                                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(currency)} {sgstAmount.toFixed(2)}</td>
                                                    </tr>
                                                </>
                                            )}
                                            {tax === "Igst" && (
                                                <tr>
                                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>IGST ({igst}%):</td>
                                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(currency)} {igstAmount.toFixed(2)}</td>
                                                </tr>
                                            )}
                                            {tax === "GST" && (
                                                <tr>
                                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>GST ({gst}%):</td>
                                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(currency)} {gstAmount.toFixed(2)}</td>
                                                </tr>
                                            )}
                                            {supplyAttractReverses === "Yes" && (
                                                <tr>
                                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Supply Attract Reverse Charge :</td>
                                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Yes</td>
                                                </tr>
                                            )}
                                            <tr style={{ backgroundColor: '#e7e7e7' }}>
                                                <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '18px' }}>Total:</td>
                                                <td style={{ border: '1px solid #ddd', fontWeight: '600', padding: '6px 10px', fontSize: '18px' }}>{getCurrencySymbol(currency)} {(totalAmount + cgstAmount + sgstAmount + igstAmount + gstAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                {/* <td colSpan={5} style={{ padding: '10px 10px 10px 0' }}>
                                                    <p style={{ margin: 0, fontSize: '13px' }}>
                                                        Total amount (in words) : <span style={{ fontWeight: '500', paddingLeft: '5px' }}>{currency} {amountInWords.toUpperCase()} Only.</span>
                                                    </p>
                                                </td> */}
                                                <td colSpan={5} style={{ padding: "10px 10px 10px 0" }}>
                                                    <p style={{ margin: 0, fontSize: "13px" }}>
                                                        Total amount (in words) :
                                                        <span style={{ fontWeight: 500, paddingLeft: "5px" }}>
                                                            {currency} {amountInWords.toUpperCase()}.
                                                        </span>
                                                    </p>
                                                </td>
                                            </tr>
                                            {remarks && (
                                                <tr>
                                                    <td colSpan={5} style={{ padding: '10px 10px 10px 0', verticalAlign: 'top' }}>
                                                        <p style={{ margin: 0 }}>
                                                            <span style={{ fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>Remarks :</span>
                                                            <span style={{ fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>{remarks}</span>
                                                        </p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="5" style={{ padding: "10px 0" }}></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="3" style={{ padding: "15px 10px", verticalAlign: "top", borderTop: "1px solid #ddd" }}>
                                                    <div style={{ display: "flex" }}>
                                                        <div style={{ paddingRight: "10px", textAlign: "center" }}>
                                                            <p style={{ margin: "0 0 6px 0", fontSize: "12px", fontWeight: 600 }}>Pay Using UPI :</p>
                                                            <img
                                                                src="https://ik.imagekit.io/blackboxv2/Graphe-logo/Graphe%CC%84%20QR%20Code.png?updatedAt=1743494152821"
                                                                alt="UPI QR Code"
                                                                style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                                            />
                                                            <small style={{ display: "block", fontSize: "12px", fontWeight: 400 }}>
                                                                yashashwi.malani@okhdfcbank
                                                            </small>
                                                        </div>

                                                        <div style={{ width: "calc(100% - 120px)", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                                                            <p style={{ margin: "0 0 6px 0", fontSize: "13px", fontWeight: 600 }}>Bank Details :</p>
                                                            <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                                                <li style={{ display: "flex", marginBottom: "3px" }}>
                                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C Name :</span>
                                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)", lineHeight: 1.3 }}>
                                                                        {template.company_name || "N/A"}
                                                                        <small style={{ margin: "2px 0 0px 0", fontSize: "11px", fontWeight: 400, color: "#858585", display: "block" }}>
                                                                            Pay By CHEQUE/DD/RTGS/NEFT
                                                                        </small>
                                                                    </span>
                                                                </li>
                                                                <li style={{ display: "flex" }}>
                                                                    <span style={{ width: "80px", marginRight: "5px" }}>Bank :</span>
                                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                                        {template?.bank_name || "N/A"}
                                                                    </span>
                                                                </li>
                                                                <li style={{ display: "flex" }}>
                                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C NO :</span>
                                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                                        {template?.account_number || "N/A"}
                                                                    </span>
                                                                </li>
                                                                <li style={{ display: "flex" }}>
                                                                    <span style={{ width: "80px", marginRight: "5px" }}>IFSC :</span>
                                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                                        {template?.ifsc_code || "N/A"}
                                                                    </span>
                                                                </li>
                                                                <li style={{ display: "flex" }}>
                                                                    <span style={{ width: "80px", marginRight: "5px" }}>Branch :</span>
                                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                                        {template?.bank_branch || "N/A"}
                                                                    </span>
                                                                </li>
                                                                <li style={{ display: "flex" }}>
                                                                    <span style={{ width: "80px", marginRight: "5px" }}>Swift Code :</span>
                                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                                        {template?.swift_code || "N/A"}
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ padding: "15px 10px", textAlign: "right", verticalAlign: "top", borderTop: "1px solid #ddd" }} colSpan="2">
                                                    <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                                                        <div>
                                                            <small style={{ marginRight: "50px" }}>
                                                                <img
                                                                    src="https://ik.imagekit.io/blackboxv2/Graphe-logo/stamp.jpeg?updatedAt=1737015027907"
                                                                    alt="Stamp"
                                                                    style={{ width: "80px", height: "80px", objectFit: "contain" }}
                                                                />
                                                            </small>
                                                        </div>
                                                        <div style={{ textAlign: "center" }}>
                                                            <p style={{ display: "block", fontSize: "14px", margin: "0 0 18px 0", fontWeight: 500 }}>
                                                                <small>For The Graphē</small>
                                                            </p>
                                                            <img src={template?.signatures?.[0]?.signature_url} alt="Signature" style={{ width: "80px", height: "80px" }} />
                                                            <p style={{ display: "block", fontSize: "14px", margin: "18px 0 0 0", fontWeight: 400 }}>
                                                                <small>Authorised Signatory</small>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style={{ backgroundColor: "#f7f7f7" }}>
                                                <td colSpan="5" style={{ padding: "10px 10px 0 10px", color: "#575757" }}>
                                                    <p style={{ margin: "0 0 5px 0", fontSize: "13px", fontWeight: 600 }}>
                                                        <span>Terms and Conditions : </span>
                                                    </p>
                                                    {[
                                                        "Payment: Due within 7 days. Late payments attract interest as per the MSME Act, 2006.",
                                                        "Interest on Late Payment: As per Section 16 of the MSME Act, 2006, delays beyond 45 days from the invoice date will attract interest at *24% P.A*",
                                                        "Intellectual Property: Final designs are transferred upon full payment. Unpaid concepts remain the agency’s property.",
                                                        "Considering the nature of services, TDS shall be calculated at 1% under section 194 (C) and 2% under section 194 (J).",
                                                        "Taxes: GST applicable as per law. Any tax changes are the client’s responsibility.",
                                                        "Payment: 50% advance before initiation of project and balance before final deliverables.",
                                                        "Jurisdiction: Disputes fall under Kolkata, West Bengal, jurisdiction.",
                                                        "A valid purchase order or work order is required for the commencement of the project."
                                                    ].map((text, index) => (
                                                        <p key={index} style={{ margin: "0 0 5px 0", fontSize: "12px", fontWeight: 400 }}>{index + 1}. {text}</p>
                                                    ))}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="5" style={{ backgroundColor: "#313030", padding: "10px 15px", textAlign: "center" }}>
                                                    <small style={{ fontSize: "13px", fontWeight: 400, color: "#fff" }}>
                                                        Call: {template?.contact_no || "N/A"} &nbsp;| &nbsp;
                                                        Email: <a href={`mailto:${template?.email}`} style={{ color: "#fff" }}>{template?.email || "N/A"}</a>
                                                    </small>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </Col>
                        </Row>
                    </Row>
                </Row >
            )}

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>
        </>
    );
};

export default CreateTaxInvoice;